export const baseUrl = window.location.origin + "/assets";
